import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"

import AppLogo from "@/components/app-logo"
import AppLogoIcon from "@/components/app-logo-icon"

interface ContentPageLayoutProps {
  children: ReactNode
}

export default function ContentPageLayout({
  children,
}: ContentPageLayoutProps) {
  return (
    <div className="vignette noise bg-bg-body text-bone min-h-screen">
      {/* Navigation */}
      <nav className="from-bg-body fixed inset-x-0 top-0 z-50 bg-gradient-to-b to-transparent px-6 py-4">
        <div className="mx-auto flex max-w-4xl items-center justify-between">
          <Link href="/" className="flex items-center">
            <AppLogo />
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="mx-auto max-w-4xl px-6 pt-24 pb-12 lg:pt-32">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-border bg-bg-body border-t px-6 py-6">
        <div className="mx-auto flex max-w-4xl flex-col items-center justify-between gap-4 md:flex-row">
          <div className="text-bone-muted flex items-center gap-2 text-sm">
            <AppLogoIcon className="text-red h-5 w-5" />
            ToDoOrDie &copy; {new Date().getFullYear()}
          </div>
          <div className="text-bone-muted flex gap-6 text-sm">
            <Link href="/privacy" className="hover:text-bone transition-colors">
              Privacy
            </Link>
            <Link href="/terms" className="hover:text-bone transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
